/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import gql from "graphql-tag";

export const  GET_TRANSACTION_LIST= gql`
  query Query($input1: GetTxnListInput) {
    getTxnList(input: $input1) {
      data {
        action
        payload
        id
        txnOwner {
          email
          firstName
          fullName
          image
          lastName
        }
        performedBy {
          firstName
          lastName
        }
        type
        when
        where
      }
      pageSize
      totalCount
      totalPages
      currentPage
    }
  }
`;
